"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcRem = void 0;
function calcRem(width, height, breakpoint) {
    if (!breakpoint.width && !breakpoint.height) {
        return 1;
    }
    if (!breakpoint.height) {
        return width / breakpoint.width;
    }
    if (!breakpoint.width) {
        return height / breakpoint.height;
    }
    const ab = breakpoint.width / breakpoint.height;
    const avp = width / height;
    const rem = ab < avp
        ? (height / breakpoint.height)
        : (width / breakpoint.width);
    return rem;
}
exports.calcRem = calcRem;
//# sourceMappingURL=rem.js.map